import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit'

export const InstanceSlice =  createSlice({
    name:"Instance",
    initialState:{
        id:"",
    },
    reducers:{
        SetInstance(state, action: PayloadAction<any>){
            state.id = action.payload;

        }
    }
});

export const { SetInstance } =InstanceSlice.actions
export default InstanceSlice.reducer